import * as marietta from '../../../..';
import { Dialog } from '../../../../core/view';
import { ITEM_MODE_NO } from '../../../Constants';
import * as THREE from 'three';
import { pix2D } from '../../../../LiDAR/graphicLibs/util/unit';
import { ThreeView } from '../../../../view3d/webcad';
import { WizardManager } from './WizardManager';

/**
 * 部屋種別変更ダイアログ
 */
export class WizardRoomTypeSelection extends Dialog {
    targetRoom: marietta.webcad.item.Room;
    itemList: marietta.webcad.item.Room[];
    currentIndex: number = 0;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'roomTypeSelectionWizardDialog';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Select Room Type'; break;
        default: title = '部屋の種類を選択してください'; break;
      }
      let contents = '<div class="dialogRoomTypeBtns">\n';
      contents += '<button value="rom10_01" style="background-color:#F4F1EA"><span class="jp">洋室</span><span class="en">Bedroom</span></button>';
      contents += '<button value="rom14_01" style="background-color:#FEFBF1"><span class="jp">収納</span><span class="en">Storage</span></button>';
      contents += '<button value="rom18_01" style="background-color:#F4F1EA"><span class="jp">ﾊﾞﾙｺﾆｰ</span><span class="en">Balcony</span></button>';
      contents += '<button value="rom04_01" style="background-color:#FEFBF1"><span class="jp">L</span><span class="en">Living</span></button>';
      contents += '<button value="rom05_01" style="background-color:#FEFBF1"><span class="jp">D</span><span class="en">Dining</span></button>';
      contents += '<button value="rom06_01" style="background-color:#FEFBF1"><span class="jp">K</span><span class="en">Kitchen</span></button>';
      contents += '<button value="rom11_01" style="background-color:#FFFFFF"><span class="jp">和室</span><span class="en">Washitu</span></button>';
      contents += '<button value="rom12_01" style="background-color:#F4F1EA"><span class="jp">床の間</span><span class="en">Tokonoma</span></button>';
      contents += '<button value="rom13_01" style="background-color:#F4F1EA"><span class="jp">広縁</span><span class="en">Hiroen</span></button>';
      contents += '<button value="rom25_01" style="background-color:#FEFBF1"><span class="jp">LD</span><span class="en">LD</span></button>';
      contents += '<button value="rom26_01" style="background-color:#FEFBF1"><span class="jp">LDK</span><span class="en">LDK</span></button>';
      contents += '<button value="rom02_01" style="background-color:#F4F1EA"><span class="jp">廊下</span><span class="en">Hallway</span></button>';
      contents += '<button value="rom09_01" style="background-color:#F4FCFF"><span class="jp">浴室</span><span class="en">Bath</span></button>';
      contents += '<button value="rom08_01" style="background-color:#F4FCFF"><span class="jp">トイレ</span><span class="en">Toilet</span></button>';
      contents += '<button value="rom07_01" style="background-color:#F4FCFF"><span class="jp">洗面所</span><span class="en">Restroom</span></button>';
      contents += '<button value="rom03_01" style="background-color:#F3F3F3"><span class="jp">玄関</span><span class="en">Entrance</span></button>';
      contents += '<button value="rom01_01" style="background-color:#F3F3F3"><span class="jp">ポーチ</span><span class="en">Porch</span></button>';
      contents += '<button value="rom17_01" style="background-color:#FFFFFF"><span class="jp">吹抜け</span><span class="en">Stairwell</span></button>';
      contents += '<button value="rom27_01" style="background-color:#F3F3F3"><span class="jp">ガレージ</span><span class="en">Garage</span></button>';
      contents += '<button value="rom28_01" style="background-color:#F4F1EA"><span class="jp">土間</span><span class="en">Doma</span></button>';
      contents += '</div>';

      let footer = '';

      this.createDialog(id, title, contents, footer);

      // イベント設定
      const btns = document.querySelectorAll('.dialogRoomTypeBtns button');
      for (let i = 0, len = btns.length; i < len; i += 1) {
        btns[i].addEventListener('click', this.onSelectType);
      }

      // 部屋リスト取得
      this.itemList = ThreeView.get().wizardManager.getTargetRoom();

      this.next();
    }

    /**
     * 種類ボタンが選択された
     */
    onSelectType = (e: Event): void => {
      e.preventDefault();

      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;

      const type: string = <string>(<HTMLButtonElement>e.currentTarget).getAttribute('value');

      this.targetRoom.itemInfo.id = type;

      // eslint-disable-next-line no-multi-assign
      const roomSettings = this.targetRoom._defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(type);
      this.targetRoom.itemInfo.text = roomSettings.text; // 部屋名称のデフォルト設定
      this.targetRoom.itemInfo.text_visible = roomSettings.text_visible;
      this.targetRoom.itemInfo.text_area_visible = roomSettings.text_area_visible;
      this.targetRoom.itemInfo.area_use_jyou = roomSettings.area_use_jyou;

      // 部屋塗り、パターンの変更
      this.targetRoom.changeRoomPattern(roomSettings.color, roomSettings.design_type, roomSettings.designColor);

      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;

      // ヒストリ
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

      // 次に選択する部屋が存在しない時
      if (this.itemList.length == this.currentIndex) {
        this.finish();
        return;
      }

      this.next();
    }

    /**
     * 次の部屋へ
     */
    next = () => {
      marietta.WebCADGlobal.itemManager.currentItem = this.itemList[this.currentIndex] as marietta.webcad.item.Room; // 選択して分かりやすいようにする
      this.targetRoom = this.itemList[this.currentIndex] as marietta.webcad.item.Room;
      this.scrollPosition(this.itemList[this.currentIndex]); // 画面位置調節
      this.reposition(this.itemList[this.currentIndex]); // ダイアログと青線位置調節
      this.roomSelect(this.itemList[this.currentIndex]); // 青枠・モーダル
      this.currentIndex += 1;
    }

    /**
       * 閉じるボタンが押された
       */
    close = () => {
      // モーダルの削除
      $("#modalBgForRoomSelect").hide();

      this.closeEvent();

      ThreeView.get().wizardManager.end();
    }

    /**
     * override
     */
    closeEvent() {
      super.closeEvent();
    }

    /**
     * 次に選択する部屋が存在しない
     */
    finish() {
      marietta.WebCADGlobal.itemManager.currentItem = null;
      // パネルを閉じる
      marietta.webcad.WebCADGlobal.removeDialog();
      // 青枠・モーダルの削除
      $("#modalBgForRoomSelect").hide();

      // 次のwizardに進む
      if (new WizardManager().getTargetPin().length == 0) ThreeView.get().wizardManager.end();
      else ThreeView.get().wizardManager.next(1);
    }

    /**
     * 画面の位置調節
     */
    scrollPosition(room: marietta.webcad.item.Room): void {

        //部屋のバウンド
        const _bound = room.viewObj.getBoundingClientRect();
        const bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

        //scroll the screen if object not in the visible screen
        const view2D: HTMLElement = document.getElementById("webcad2dViewInner");
        const currentScrollPosition: marietta.core.Point = new marietta.core.Point(view2D.scrollLeft, view2D.scrollTop);
        let { top, left, bottom, right } = view2D.getBoundingClientRect();
        let scrollBarWidth = view2D.offsetWidth - view2D.clientWidth;
        right = right - left - scrollBarWidth;
        bottom = bottom - top - scrollBarWidth;
        const margin = 100;
        let xDiff = 0, yDiff = 0;
        if (bound.x < left) xDiff = bound.x - left - margin - bound.width;
        if (bound.y < top) yDiff = bound.y - top - margin - bound.height;

        if (bound.x > right) xDiff = bound.x - right + margin + bound.width;
        if (bound.y > bottom) yDiff = bound.y - bottom + margin + bound.height;

        marietta.webcad.WebCADGlobal.scrollerManager.setScrollPosition(currentScrollPosition.x + xDiff, currentScrollPosition.y + yDiff);

    }

    /**
     * 青枠・モーダル
     */
    roomSelect(room: marietta.webcad.item.Room): void {

        //異なる階の場合は、階を変更する
        const targetFloor: number = room.itemInfo.floor;
        if (targetFloor != marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) {
            marietta.webcad.WebCADGlobal.changeFloor(targetFloor);
        }

        // y軸の最大値
        let index;
        let max = 0;
        room.itemInfo.dotList.forEach((points: marietta.webcad.collection.PointCollection, i: number) => {
          if (max < points.y) {
            max = points.y;
            index = i;
          }
        });

        let count = 0;
        const dotList = [];
        let i = index;
        while(count < room.itemInfo.dotList.length) {
          dotList.push(room.itemInfo.dotList[i]);
          i = (i+1)%room.itemInfo.dotList.length;
          count += 1;
        }

        // スクロール分
        const left = document.getElementById('webcad2dViewInner').scrollLeft;
        const top = document.getElementById('webcad2dViewInner').scrollTop;
        // 部屋のオフセット値
        const offsetX = room.spt.x * marietta.webcad.WebCADGlobal.scaleSize;
        const offsetY = room.spt.y * marietta.webcad.WebCADGlobal.scaleSize;
        // ヘッダー
        const header = 50;
        // 左メニュー
        const leftMenu = 39;

        const createPath = (): string => {
          let _path: string = '';
          dotList.forEach((points: marietta.webcad.collection.PointCollection) => {
            _path += ' L' + Math.abs(left - points.x * marietta.webcad.WebCADGlobal.scaleSize - header - offsetX) + ',' + Math.abs(top - points.y * marietta.webcad.WebCADGlobal.scaleSize - leftMenu - offsetY);
          });

          return _path;
        }

        //グレイを作る
        const path: string = "M0, 0" +
            "L" + window.innerWidth + ", 0" +
            "L" + window.innerWidth + "," + window.innerHeight +
            "L" + Math.abs(left - dotList[0].x * marietta.webcad.WebCADGlobal.scaleSize - header - offsetX) + "," + window.innerHeight +
            createPath() +
            "L" + Math.abs(left - dotList[0].x * marietta.webcad.WebCADGlobal.scaleSize - header - offsetX) + "," + Math.abs(top - dotList[0].y * marietta.webcad.WebCADGlobal.scaleSize - leftMenu - offsetY) +
            "L" + Math.abs(left - dotList[0].x * marietta.webcad.WebCADGlobal.scaleSize - header - offsetX) + "," + window.innerHeight +
            "L 0," + window.innerHeight +
            " L 0, 0Z";
        document.getElementById("modalBgForRoomSelect_fill")?.setAttribute("d", path);

        $("#modalBgForRoomSelect").show();
        $("#modalBg").hide();

    }

    /**
     * ダイアログの位置調節
     */
    reposition(target: marietta.webcad.item.Room): any {
        //ダイアログの位置
        //部屋が右半分のところにある
        const _bound = target.viewObj.getBoundingClientRect();
        let bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

        const mybound = document.getElementById('roomTypeSelectionWizardDialog').getBoundingClientRect();
        // const margin: number = 100;
        let posX: number = 0;
        let posY: number = 0;

        // 上下左右の差分
        const top = bound.y;
        const bottom = window.innerHeight - (bound.y + bound.height);
        const right = window.innerWidth - (bound.x + bound.width);
        const left = bound.x;

        // 位置計算
        if (top > bottom && top > right && top > left) {
          posX = 0;
          posY = - top / 2 + mybound.height / 2;
        } else if (bottom > top && bottom > right && bottom > left) {
          posX = 0;
          posY = top / 2;
        } else if (right > top && right > bottom && right > left) {
          posX = left / 2;
          posY = 0;
        } else if (left > top && left > bottom && left > right) {
          posX = - left / 2 + mybound.width / 2;
          posY = 0;
        }

        // 画面いっぱいに表示されている場合は中央にする
        if (bound.height > top && bound.height > bottom && bound.width > left && bound.width > right) {
          posX = 0;
          posY = 0;
        }

        // 画面外のケースは中央にする
        if (posX < - window.innerWidth / 2 || window.innerWidth / 2 < posX
        || posY < - window.innerHeight / 2 || window.innerHeight / 2 < posY) {
          posX = 0;
          posY = 0;
        }

        this.dialogPosition.x = posX;
        this.dialogPosition.y = posY;

        const cssTransform = 'translate(' + posX + 'px,' + posY + 'px)';
        $(this.viewObj).css({ transform: cssTransform });

    }


}
